module.exports = __webpack_public_path__ + "static/media/Monday_Step4_Image7.278e0979.webp";